module.exports = __webpack_public_path__ + "img/Cópia de Alls Technology (1).0b5d136c.jpg";